const villa_sec1_part4Object = payload => {
  return {
    type: "villasec1part4",
    payload
  };
};

export default villa_sec1_part4Object;
